import { render, staticRenderFns } from "./NotificationHandler.vue?vue&type=template&id=0d3fe84e&scoped=true&"
import script from "./NotificationHandler.vue?vue&type=script&lang=js&"
export * from "./NotificationHandler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d3fe84e",
  null
  
)

export default component.exports